import moment from "moment";
import {
  ADD_RIGHT,
  DELETE_RIGHT,
  PUBLIC_TOKEN,
  PUBLIC_URL,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "./constants";
import numeral from "numeral";
import { isArray, isString } from "lodash";

numeral.register("locale", "vi", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "Nghìn",
    million: "Triệu",
    billion: "Tỷ",
    trillion: "Nghìn Tỷ",
  },
  currency: {
    symbol: "₫",
  },
  ordinal: (number) => number + "",
});
numeral.locale("vi");

function formatDateDisplay(date: any, format = "DD/MM/YYYY") {
  if (!date) return;
  if (!moment(date).isValid()) return date;
  return moment(date).format(format);
}

// generate search keywords
const generateSearchKeywords = (
  obj: {
    [key: string]: any;
  },
  stringify: boolean = true
) => {
  let result = "";
  for (let key in obj) {
    const res = !!stringify ? JSON.stringify(obj[key]) : obj[key];
    result += `${!result ? "?" : "&"}${key}=${res}`;
  }
  return result;
};

// generate random string
function generateRandomString(length: number) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

// generate link image
const generateLinkImage = (link: string) => {
  return `${PUBLIC_URL}${link}?access_token=${PUBLIC_TOKEN}`;
};

type downloadFileType = {
  link: string;
  successMessage?: string;
};
const downloadFile = ({ link, successMessage }: downloadFileType) => {
  if (!link) return;
  try {
    const aTag = document.createElement("a");
    aTag.href = link;
    aTag.download = "true";
    aTag.click();
    return {
      status: 200,
      message: 'Đã tải về file'
    }
  } catch (error: any) {
    return {
      status: 500,
      message: error?.error || error?.message || "Lỗi khi tải file"
    }
  }
};

type allowShowAuthorizeType = {
  module: string | string[];
  rights: {
    module: string;
    [VIEW_RIGHT]: boolean;
    [VIEWOFOTHER_RIGHT]: boolean;
    [ADD_RIGHT]: boolean;
    [UPDATE_RIGHT]: boolean;
    [DELETE_RIGHT]: boolean;
  }[];
};
const allowShowAuthorize = ({ module, rights }: allowShowAuthorizeType) => {
  if (isArray(module)) {
    for (let i = 0; i < module.length; i++) {
      const currentRight = rights.find((r) => r.module === module[i]);
      if (currentRight?.[VIEW_RIGHT] || currentRight?.[VIEWOFOTHER_RIGHT]) {
        return true;
      }
    }
    return false;
  } else if (isString(module)) {
    const existed = rights.find((r) => r.module === module);
    if (existed && (existed[VIEW_RIGHT] || existed[VIEWOFOTHER_RIGHT])) {
      return true;
    }
  }
  return false;
};

function acceptParentheses(str: string) {
  if (!str) return "";
  return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}

export {
  numeral as numeralCustom,
  formatDateDisplay,
  generateSearchKeywords,
  generateRandomString,
  generateLinkImage,
  downloadFile,
  allowShowAuthorize,
  acceptParentheses,
};
